// tslint:disable:no-string-literal
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import * as React from 'react';

import StaticDocumentsQuery from '../../components/Query/StaticDocuments';
import StaticDocumentDetail from './StaticDocumentDetail';
import { Title } from '../../components/Layout/components';

interface IStaticDocumentsTableState {
  staticDocument?: GQL.IStaticDocument;
}

interface IStaticDocumentsTableProps {
  domain: string;
}

export default class StaticDocumentsTable extends React.Component<IStaticDocumentsTableProps, IStaticDocumentsTableState> {

  constructor(props: IStaticDocumentsTableProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <StaticDocumentsQuery domain={this.props.domain}>
            {({ staticDocuments, deleteStaticDocument, createStaticDocument, updateStaticDocument }: any) => {
              return this.renderData(
                staticDocuments,
                updateStaticDocument,
                createStaticDocument,
                deleteStaticDocument,
                staticDocuments.refetch
              );
            }}
          </StaticDocumentsQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    staticDocumentsQuery: any,
    updateStaticDocument: Function,
    createStaticDocument: Function,
    deleteStaticDocument: Function,
    refetch: Function
  ) {
    if (!staticDocumentsQuery.loading) {
      return (
        <div>
          <Title>Documents</Title>
          <Divider />
          <Button onClick={() => this.newStaticDocument()}>Create new document</Button>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={staticDocumentsQuery.staticDocuments || []}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Title" dataIndex="title" key="title" />
            <Table.Column
              width={300}
              title="Actions"
              dataIndex="actions"
              key="actions"
              render={(u: any, row: any) => this.renderActions(u, row, deleteStaticDocument, refetch)}
            />
          </Table>
          {this.state &&
            this.state.staticDocument && (
              <StaticDocumentDetail
                languages={staticDocumentsQuery.languages}
                staticDocument={this.state.staticDocument}
                onSave={a => this.upsert(a, updateStaticDocument, createStaticDocument, refetch)}
                onCancel={() => this.setCurrentStaticDocument(undefined)}
              />
            )}
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading static documents ..." style={{ width: '100%' }} />
      </div>
    );
  }

  // @ts-ignore
  private renderActions(u: any, staticDocument: GQL.IStaticDocument, deleteStaticDocument: Function, refetch: Function) {
    return (
      <div>
        <Button type={'dashed'} onClick={() => this.setCurrentStaticDocument(staticDocument)}>
          Edit
        </Button>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(staticDocument, deleteStaticDocument, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private newStaticDocument() {
    this.setCurrentStaticDocument({
      name: '',
      description: '',
      categories: []
    });
  }

  private setCurrentStaticDocument(staticDocument: any) {
    this.setState({ staticDocument });
  }

  private delete(staticDocument: GQL.IStaticDocument, deleteStaticDocument: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${staticDocument.title}?`,
      content: (
        <span>
          Are you sure you want to delete static document <strong>{staticDocument.title}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteStaticDocument({
          variables: {
            id: staticDocument.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    staticDocument: GQL.IStaticDocument,
    updateStaticDocument: Function,
    createStaticDocument: Function,
    refetch: Function
  ) {
    if (staticDocument != undefined) {
      const variables = {
        id: staticDocument.id,
        staticDocument: {
          title: staticDocument.title,
          html: staticDocument.html,
          tags: staticDocument.tags || []
        }
      };

      if (staticDocument.id) {

        return updateStaticDocument({ variables })
          .then(() => this.setCurrentStaticDocument(null))
          .then(() => refetch())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Static document "${variables.staticDocument.title}" has been updated.`
            })
          );
      }

      (variables.staticDocument as any).domain = this.props.domain;

      createStaticDocument({ variables })
        .then(() => this.setCurrentStaticDocument(null))
        .then(() => refetch())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Static document "${variables.staticDocument.title}" has been created.`
          })
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/StaticDocuments/StaticDocumentsTable.tsx